import React from 'react'
import { adminPath } from '@shared/adminPath'
import "./index.css"
import certificatePendingIcon from "./images/certificate-pending.svg";
import certificateGeneratedIcon from "./images/certificate-generated.svg";
import certificateSignedIcon from "./images/certificate-signed.svg";
import { withRouter } from '../../utils/withRouter';
import { connect } from 'react-redux';

const CERTIFICATE_BY_TYPE = {
  pending: {icon: certificatePendingIcon, label: 'Pendente Assinatura'},
  generated: {icon: certificateGeneratedIcon, label: 'Certificado Gerado'},
  signed: {icon: certificateSignedIcon, label: 'Certificado Assinado'}
}

const CardCertificate = ({ id, name, schoolName, subordersCount, productsCount, createdDate, status, navigate }) => {

  const getFormatedDate = () => {
    const date = new Date(createdDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  const goSeeCertificate = () => {
    navigate(adminPath(`/certificados-entrega/visualizar/${id}`))
  }

  return (
    <div className="card-certificate">
      <div className="card-certificate__details">
        <div className="card-certificate__details__date">{getFormatedDate()}</div>

        <div className="card-certificate__details__item w-large names">
          <div className="card-certificate__details__item__text large red ellipsis" title={name}>{name}</div>
          <div className="card-certificate__details__item__text small red ellipsis" title={schoolName}>{schoolName}</div>
        </div>

        <div className="card-certificate__details__item w-small">
          <div className="card-certificate__details__item__text medium">Quantidade<br /> de pedidos</div>
          <div className="card-certificate__details__item__text large">{(''+subordersCount).padStart(2, '0')}</div>
        </div>

        <div className="card-certificate__details__item w-small">
          <div className="card-certificate__details__item__text medium">Quantidade<br /> de produtos</div>
          <div className="card-certificate__details__item__text large">{(''+productsCount).padStart(2, '0')}</div>
        </div>

        <div className="card-certificate__details__item w-medium">
          <button className="button__small button__normal--white" onClick={() => goSeeCertificate()}>
            Ver detalhes
          </button>
        </div>
      </div>
      <div className={ `card-certificate__status ${status}`}>
        <img src={CERTIFICATE_BY_TYPE[status].icon} />
        {CERTIFICATE_BY_TYPE[status].label}
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps =  {
}

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...props,
  navigate: props.navigate,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(CardCertificate))